<template>
    <div class="success-page page-main no-shadow">
      <div class="success-box text-color-black">
          <div class="spaceCenter" style="margin-bottom:27px;">
              <svg class="icon login-input-i" aria-hidden="true">
                  <use xlink:href="#gold-icon-tijiaowancheng"></use>
              </svg>
          </div>
          <div class="spaceCenter text">
              {{text}}
          </div>
      </div>
      <div class="spaceCenter">
          <div class="success-text">银行审核通过后，将向您在平台的预留手机号码发送审核结果通知，请注意查收。</div>
      </div>

    </div>
</template>

<script>
export default {
    name:"success",
    props:["text"],
    components: {},
    data() {
        return {

        };
    }
}
</script>
<style scoped lang="less">
    .success-page{
        min-height: 300px;
        padding:100px 0;
    }
    .success-box{
        font-size: 20px;
        margin: 0 auto 10px auto;
        .icon{
            margin-right: 10px;
            font-size: 84px;
        }
        .text{
            font-size: 24px;
            font-weight: bold;
            color:#333;
        }
    }
    .success-text{
        max-width: 300px;
        color: #999;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/bank/bank-step-success.vue